// Data structure for main service categories
export const serviceCategories = [
  {
    id: '1',
    title: 'Custom Home Building',
    description: 'Bespoke residential projects crafted to your specifications, from concept to completion.',
    icon: 'home'
  },
  {
    id: '2',
    title: 'Renovations & Additions',
    description: 'Transform your existing space with thoughtful renovations that enhance form and function.',
    icon: 'building'
  },
  {
    id: '3',
    title: 'Commercial Projects',
    description: 'Sophisticated commercial spaces designed for brand expression and functionality.',
    icon: 'building-office'
  }
];

// Categories for Renovations & Additions (id: '2')
export const renovationCategories = [
  {
    id: 'kitchen',
    name: 'Kitchen',
    description: 'Modern kitchen renovations and upgrades',
    image: 'https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/148-150_Clinton_-kitchen02-2-scaled.jpg'
  },
  {
    id: 'bathroom',
    name: 'Bathroom',
    description: 'Luxurious bathroom transformations',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'structural',
    name: 'Structural',
    description: 'Repair structural elements to ensure safety and stability',
    image: 'https://images.unsplash.com/photo-1615874959474-d609969a20ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'livingroom',
    name: 'Living Room',
    description: 'Sophisticated living space designs',
    image: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'basement',
    name: 'Basement',
    description: 'Transform your basement into a functional space',
    image: 'https://images.unsplash.com/photo-1594122230689-45899d9e6f69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'outdoor',
    name: 'Outdoor Space',
    description: 'Beautiful backyard and patio designs',
    image: 'https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/2N-Outdoor_staged_2-scaled.jpg'
  }
];

// Categories for Custom Home Building (id: '1')
export const customHomeCategories = [
  {
    id: 'modern',
    name: 'Modern Design',
    description: 'Clean lines and minimalist aesthetics',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'traditional',
    name: 'Traditional Style',
    description: 'Classic designs with timeless appeal',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'contemporary',
    name: 'Contemporary',
    description: 'Current trends with innovative materials',
    image: 'https://images.unsplash.com/photo-1600573472550-8090733a21e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'ecological',
    name: 'Ecological',
    description: 'Sustainable and environmentally friendly homes',
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'luxury',
    name: 'Luxury',
    description: 'High-end finishes and premium amenities',
    image: 'https://images.unsplash.com/photo-1599809275671-b5942cabc7a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'farmhouse',
    name: 'Farmhouse',
    description: 'Rustic charm with modern conveniences',
    image: 'https://images.unsplash.com/photo-1595514535804-24a15cdc87f9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  }
];

// Categories for Commercial Projects (id: '3')
export const commercialCategories = [
  {
    id: 'retail',
    name: 'Retail Spaces',
    description: 'Engaging storefronts and shopping experiences',
    image: 'https://images.unsplash.com/photo-1582037928769-59c9e4b5695b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'office',
    name: 'Office Buildings',
    description: 'Modern workspaces designed for productivity',
    image: 'https://images.unsplash.com/photo-1497366858526-0766cadbe8fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'restaurant',
    name: 'Restaurants & Cafes',
    description: 'Unique dining experiences with aesthetic appeal',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'hotel',
    name: 'Hotels & Hospitality',
    description: 'Comfortable and stylish accommodation spaces',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'medical',
    name: 'Medical Facilities',
    description: 'Healthcare spaces designed for wellbeing',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'industrial',
    name: 'Industrial Buildings',
    description: 'Functional and efficient industrial spaces',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
  }
];


// For kitchen category specifically (used in details.js)
export const kitchenSubCategories = [
  { id: 'countertops', name: 'Countertop Installation' },
  { id: 'flooring', name: 'Flooring' },
  { id: 'layout', name: 'Kitchen Layout' },
  { id: 'painting', name: 'Painting' },
  { id: 'appliances', name: 'Appliances' },
  { id: 'cabinets', name: 'Cabinets' },
  { id: 'demolition', name: 'Demolition' },
  { id: 'lighting', name: 'Kitchen Lighting' },
  { id: 'sink', name: 'Kitchen Sinks' },
  { id: 'plumbing', name: 'Plumbing' }
];

// For bathroom category specifically (used in details.js)
export const bathroomSubCategories = [
  { id: 'tub', name: 'Bathtub Installation' },
  { id: 'shower', name: 'Shower Installation' },
  { id: 'toilet', name: 'Toilet Installation' },
  { id: 'vanity', name: 'Vanity' },
  { id: 'tile', name: 'Tile Work' },
  { id: 'flooring', name: 'Bathroom Flooring' },
  { id: 'plumbing', name: 'Plumbing Fixtures' },
  { id: 'ventilation', name: 'Ventilation/Exhaust' },
  { id: 'lighting', name: 'Bathroom Lighting' },
  { id: 'demolition', name: 'Demolition' }
];

// Add subcategories for other renovation categories
export const structuralSubCategories = [
  { id: 'foundation', name: 'Foundation Repair' },
  { id: 'beams', name: 'Beam Installation/Replacement' },
  { id: 'walls', name: 'Load-bearing Wall Modification' },
  { id: 'framing', name: 'Framing Repair' },
  { id: 'roofing', name: 'Roof Structure Repair' },
  { id: 'waterproofing', name: 'Structural Waterproofing' },
  { id: 'insulation', name: 'Structural Insulation' },
  { id: 'seismic', name: 'Seismic Retrofitting' }
];

export const livingRoomSubCategories = [
  { id: 'structural-changes', name: 'Structural Changes' },
  { id: 'interior-design', name: 'Interior Design' },
  { id: 'fireplace-mantel', name: 'Fireplace & Mantel' },
  { id: 'lighting', name: 'Lighting Solutions' },
  { id: 'windows-doors', name: 'Windows & Doors' },
  { id: 'audio-visual', name: 'Audio/Visual Setup' },
  { id: 'furniture-layout', name: 'Furniture & Layout' }
];

export const basementSubCategories = [
  { id: 'finishing', name: 'Basement Finishing' },
  { id: 'waterproofing', name: 'Waterproofing & Moisture Control' },
  { id: 'insulation', name: 'Insulation & Climate Control' },
  { id: 'flooring', name: 'Flooring Solutions' },
  { id: 'lighting', name: 'Lighting & Electrical' },
  { id: 'plumbing', name: 'Plumbing & Fixtures' },
  { id: 'layout-design', name: 'Layout & Design Optimization' }
];

// Add subcategories for Custom Home Building categories
export const modernHomeSubCategories = [
  { id: 'openplan', name: 'Open Floor Plan' },
  { id: 'minimalist', name: 'Minimalist Design' },
  { id: 'glass', name: 'Large Glass Elements' },
  { id: 'smarttech', name: 'Smart Home Technology' },
  { id: 'flatroof', name: 'Flat Roof Design' },
  { id: 'industrial', name: 'Industrial Design Elements' }
];

export const traditionalHomeSubCategories = [
  { id: 'molding', name: 'Crown Molding & Trim' },
  { id: 'fireplace', name: 'Classic Fireplace Mantels' },
  { id: 'porch', name: 'Front Porch Designs' },
  { id: 'roof', name: 'Gabled Roof Architecture' },
  { id: 'paneling', name: 'Wall Paneling' }
];

export const contemporaryHomeSubCategories = [
  { id: 'asymmetry', name: 'Asymmetrical Facades' },
  { id: 'mixedmaterials', name: 'Mixed Materials' },
  { id: 'largewindows', name: 'Large Window Installations' },
  { id: 'flatroof', name: 'Flat Roof Construction' },
  { id: 'openinterior', name: 'Open Interior Spaces' }
];

export const ecologicalHomeSubCategories = [
  { id: 'solar', name: 'Solar Panels' },
  { id: 'greenroof', name: 'Green Roofs' },
  { id: 'geothermal', name: 'Geothermal Heating' },
  { id: 'recycled', name: 'Recycled Materials' },
  { id: 'rainwater', name: 'Rainwater Harvesting' }
];

export const luxuryHomeSubCategories = [
  { id: 'spa', name: 'In-home Spa' },
  { id: 'theater', name: 'Private Theater' },
  { id: 'winecellar', name: 'Wine Cellar' },
  { id: 'grandentry', name: 'Grand Entryway' },
  { id: 'customstone', name: 'Custom Stonework' }
];

export const farmhouseHomeSubCategories = [
  { id: 'shiplap', name: 'Shiplap Walls' },
  { id: 'barndoors', name: 'Sliding Barn Doors' },
  { id: 'wraparound', name: 'Wraparound Porch' },
  { id: 'farmkitchen', name: 'Farmhouse Kitchen' },
  { id: 'reclaimedwood', name: 'Reclaimed Wood Features' }
];

// Add subcategories for Commercial Project categories
export const retailSubCategories = [
  { id: 'storefront', name: 'Storefront Design' },
  { id: 'display', name: 'Display Systems' },
  { id: 'lighting', name: 'Retail Lighting' },
  { id: 'flooring', name: 'Commercial Flooring' },
  { id: 'checkout', name: 'Checkout Counter Design' },
  { id: 'storage', name: 'Storage Solutions' }
];

export const officeSubCategories = [
  { id: 'workstations', name: 'Workstation Layouts' },
  { id: 'conference', name: 'Conference Rooms' },
  { id: 'acoustic', name: 'Acoustic Solutions' },
  { id: 'lighting', name: 'Office Lighting' },
  { id: 'networking', name: 'Networking & Cabling' },
  { id: 'breakroom', name: 'Break Room Setup' }
];

export const restaurantSubCategories = [
  { id: 'kitchen', name: 'Commercial Kitchen Setup' },
  { id: 'dining', name: 'Dining Area Design' },
  { id: 'bar', name: 'Bar Design' },
  { id: 'hvac', name: 'Ventilation & HVAC' },
  { id: 'restrooms', name: 'Restroom Fixtures' },
  { id: 'lighting', name: 'Restaurant Lighting' }
];

export const hotelSubCategories = [
  { id: 'guestrooms', name: 'Guest Room Design' },
  { id: 'lobby', name: 'Lobby Design' },
  { id: 'amenities', name: 'Amenity Spaces (Gym, Spa)' },
  { id: 'elevators', name: 'Elevator Installation' },
  { id: 'hallways', name: 'Corridor Finishes' },
  { id: 'bathrooms', name: 'Hotel Bathroom Fixtures' }
];

export const medicalSubCategories = [
  { id: 'exam', name: 'Exam Room Setup' },
  { id: 'waiting', name: 'Waiting Room Design' },
  { id: 'surgical', name: 'Surgical Suite Buildout' },
  { id: 'compliance', name: 'ADA & Compliance Upgrades' },
  { id: 'sterile', name: 'Sterilization Zones' },
  { id: 'plumbing', name: 'Medical Gas & Plumbing' }
];

export const industrialSubCategories = [
  { id: 'warehouse', name: 'Warehouse Layout' },
  { id: 'loading', name: 'Loading Dock Construction' },
  { id: 'mezzanine', name: 'Mezzanine Installation' },
  { id: 'electrical', name: 'Industrial Electrical Work' },
  { id: 'fire', name: 'Fire Safety Systems' },
  { id: 'flooring', name: 'Heavy-Duty Flooring' }
];

// Utility function to get subcategories for a given renovation category
export const getSubcategories = (categoryId) => {
  switch (categoryId) {
    case 'kitchen':
      return kitchenSubCategories;
    case 'bathroom':
      return bathroomSubCategories;
    case 'structural':
      return structuralSubCategories;
    case 'livingroom':
      return livingRoomSubCategories;
    case 'basement':
      return basementSubCategories;
    case 'modern':
      return modernHomeSubCategories;
    case 'traditional':
      return traditionalHomeSubCategories;
    case 'contemporary':
      return contemporaryHomeSubCategories;
    case 'ecological':
      return ecologicalHomeSubCategories;
    case 'luxury':
      return luxuryHomeSubCategories;
    case 'farmhouse':
      return farmhouseHomeSubCategories;
    case 'retail':
      return retailSubCategories;
    case 'office':
      return officeSubCategories;
    case 'restaurant':
      return restaurantSubCategories;
    case 'hotel':
      return hotelSubCategories;
    case 'medical':
      return medicalSubCategories;
    case 'industrial':
      return industrialSubCategories;
    default:
      return [];
  }
};